export default "__VITE_ASSET__akauTXYy__"